import $ from 'jquery';
import Swiper from 'swiper';

export default class MobileSlider {
	constructor(options) {
		this.selector = options.selector;
		this.windwoWidth = $(window).width();
	}

	init() {
		const {selector} = this;

		const settings = {
			slidesPerView: 'auto',
			CSSWidthAndHeight: true,
			spaceBetween: 30,
			pagination: {
				el: `${this.selector}__pagination`,
				clickable: true
			}
		};

		return new Swiper(`${selector}__container`, {
			breakpoints: {
				// mobile
				767: {
					...settings,
					centeredSlides: true
				},
				// tablet
				1239: {
					...settings,
					centeredSlides: true,
					initialSlide: 1
				},
				// desktop
				9999: {
					...settings,
					noSwiping: true,
					noSwipingClass: 'no-swiping'
				}
			}
		});
	}

	makeSlider() {
		if ($(this.selector).length) {
			let mobileSlider = this.init();

			window.addEventListener('resize', () => {
				if (this.windwoWidth === $(window).width()) {
					return;
				} // handle mobile browsers viewport changes

				if (!mobileSlider.destroyed) {
					if (Array.isArray(mobileSlider)) {
						mobileSlider.forEach(instance => {
							instance.destroy();
						});
					}
					else {
						mobileSlider.destroy();
					}
				}

				this.windwoWidth = $(window).width();
				mobileSlider = this.init();
			});
		}
	}
}



// WEBPACK FOOTER //
// ./app/scripts/MobileSlider.js